import { render } from "./Efficiency.vue?vue&type=template&id=4d2c14a0"
import script from "./Efficiency.vue?vue&type=script&lang=js"
export * from "./Efficiency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__